import React from 'react';

const BS_Dropdowns = () => {
    return (
        <div>
            <h1>BS_Dropdowns Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Dropdowns;
